import { PieChart } from "@mantine/charts";
import { Center } from "@mantine/core";
import "./PassFailPieChart.css"; // Import chart styles

export type PassFailPieChartProps = {
  passRate: number;
  failRate: number;
};

export function PassFailPieChart({ passRate, failRate }: PassFailPieChartProps) {
  return (
    <div
      className="pass-fail-chart-wrapper"
      style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Center>
        <PieChart
          withLabels
          labelsPosition="inside"
          labelsType="percent"
          data={[
            { name: "Pass", value: passRate, color: "#0088ff" },
            { name: "Fail", value: failRate, color: "#0a253d" },
          ]}
          size={220}
        />
      </Center>
    </div>
  );
}
